import React from 'react';
import dynamic from 'next/dynamic';
const ProfileLayout = dynamic(() => import('@/components/landing/account/ProfileLayout'), { ssr: false });
const PurchaseHistoryComponent = dynamic(() => import('@/components/purchase-history'));

const PurchaseHistory = () => {
  return (
    <ProfileLayout>
      <PurchaseHistoryComponent />
    </ProfileLayout>
  );
};
export default PurchaseHistory;
